
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/callback-support-in-style-overrides",
      function () {
        return require("private-next-pages/blog/callback-support-in-style-overrides.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/callback-support-in-style-overrides"])
      });
    }
  